// removed by extract-text-webpack-plugin
module.exports = {"container":"f_g","hero":"f_h","heading":"f_i","grid":"f_j","section":"f_k","image":"f_l","name":"f_m","title":"f_n","description":"f_o","carouselTitle":"f_p","carouselLink":"f_q","block":"f_r"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/AboutUsPage/styles.module.css
// module id = 1238
// module chunks = 27